export default __webpack_public_path__ + "static/media/2895.77fb651f.png";